import React from 'react'
import { activities } from '../../config/constant'
import {
  setCurrentActivity,
  setSignUpActivities,
  addToSignUp,
  signUpAct
} from '../../action/activityAction';
import {
  experiences,
  noThanks,
  signMeUp
} from '../../app-text-files/enText'
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import ActvityCard from './acticvity-card/activityCard'
import { heightFix } from '../../JS/heightFix'
import { setActivityColor, ActvitySelectedColor } from '../../JS/setColors'
import { popupOpenClose, setLoadingMass } from '../../action/action'

class Activities extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ratingInstars: [],
      signUp: false,
      activities: [],
      stateCurrentActivity: this.props.currentActivity,
      starTouch: 0
      // shouldUpdate
    }
  }

  //get touch start coordinates
  handleTouchSt = (event) => {
    //console.log("touchEventStart", event.touches);
    if (event.touches) {
      return event.touches[0].clientX;
    }
    return null;
  }

  //get touch move coordinates
  handleTouchMove = (event) => {
    //console.log("touchEventMove", event.touches);
    if (event.touches) {
      return event.touches;
    }
    return null;
  }

  //change activity according to swipe direction
  handleTouchEnd = (moveTouch, startTouch, l) => {
    let startX, startY, endX, endY, xDiff, yDiff;
    if (!startTouch || !moveTouch) {
      return;
    }
    //startX = startTouch[0].clientX;
    // startY = startTouch[0].clientY;
    endX = moveTouch[0].clientX;
    endY = moveTouch[0].clientY;
    //alert(`${startTouch}, endx=${endX},l=${l}`);
    xDiff = startTouch - endX;
    //console.log("xDiff", xDiff);
    if (xDiff > 14) {
      //alert("left swipe");
      //console.log("left swipe");
      this.changeActivity("left");
    } else if (xDiff === 0) {
      //alert("no swipe its touch");
      //console.log("its click not swipe");
    } else if (xDiff < -14) {
      //alert("right swipe");
      //console.log("right swipe");
      this.addToSignUp();
    }
  }

  static getDerivedStateFromProps(props, state) {
    let act
    if (props.activities.length > 0) {
      //console.log("it show true");
      act = props.activities
    } else {
      // console.log("it show false");
      act = activities
    }
    return {
      activities: act
    }
  }

  componentDidMount() {
    setActivityColor(this.props.menuColor);
    ActvitySelectedColor(this.state.stateCurrentActivity.activityId, this.props.menuColor);
    let count = 0;
    heightFix();
    let starTouch, moveTouch, lastTouch;
    document.querySelector("#currentCard").addEventListener(
      'touchstart',
      (event) => {
        count++;
        starTouch = this.handleTouchSt(event);
        //alert(starTouch);
      }
    );
    document.querySelector("#currentCard").addEventListener(
      'touchmove',
      (event) => {
        moveTouch = this.handleTouchMove(event);
        lastTouch = event.touches[0].clientX;
      }
    );

    document.querySelector("#currentCard").addEventListener(
      'touchend',
      () => {
        this.handleTouchEnd(moveTouch, starTouch, lastTouch);
        //console.log("moveTouch,startTouch", moveTouch, starTouch);
        //alert(starTouch);
        count = 0;
        starTouch = 0;
        moveTouch = 0;
      }
    );
    let ratingInstar = this.rating(this.props.currentActivity);
    this.setState({ ratingInstars: ratingInstar })
    if (!this.props.currentActivity.name && this.state.activities.length > 0) {
      this.props.setCurrentActivity(this.state.activities[0], this.state.activities[1]);
    }
  }

  //OnClick function activity 
  onActivityClick = (currentAct, index) => {
    let ratingInstar = this.rating(currentAct);
    this.setState({
      currentActivity: currentAct,
      ratingInstars: ratingInstar
    })
    this.props.setCurrentActivity(currentAct, false);
    this.setState({ stateCurrentActivity: currentAct });
  }

  //convert rating in number in stars
  rating = (currentActivity) => {
    //console.log("current rating", this.props.currentActivity.rating)
    let [currentRating = 5] = [
      currentActivity.rating ?
        currentActivity.rating :
        5
    ];
    let ratingInstar = [];
    for (let i = 0; i < 5; i++) {
      if (currentRating - 1 >= i) {
        ratingInstar[i] = 1;
      } else {
        ratingInstar[i] = 0;
      }
    }
    return ratingInstar;
  }

  addToSignUp = () => {
    let flag = false;
    this.props.signUpActivities.map((iterator, index) => {
      if (iterator.name === this.props.currentActivity.name) {
        flag = true;
        // alert("you already signup for this activity.");
        this.props.popupOpenClose(true, "You have already signed up for this activity.");
      }
      return 0;
    })
    if (!flag) {
      //this.props.setLoadingMass(true);
      if (this.props.guestDetails.guestToken) {
        this.props.signUpAct(this.props.resNo, this.props.currentActivity,
          this.props.guestDetails, this.callbackfromAct);
      } else {
        // alert("There is no guest in this room.");
        this.props.popupOpenClose(true, "Not checked in Room.");
      }
    } else {
      this.changeActivity("right");
    }
    //this.changeActivity("right");
  }

  callbackfromAct = (status) => {
    //this.props.setLoadingMass(false);
    if (status) {
      this.props.addToSignUp(this.props.currentActivity);
      this.changeActivity("right");
    } else {
      this.props.popupOpenClose(true, "Can't signup activity, try after some time.");
      //console.log("error in sign up process");
    }
  }

  changeActivity = (whoIsIt) => {
    if (whoIsIt !== "right") {
      this.setState((state) => ({ signUp: "left" }));
    } else {
      this.setState((state) => ({ signUp: "right" }))
    }
    //this time out according to time set for swipe animation animation
    setTimeout(() => {
      this.setState(
        (state) => ({ signUp: "", stateCurrentActivity: activities[0] }))
      this.setState(
        (state) => ({ signUp: "", stateCurrentActivity: this.props.currentActivity }))
    }, 350);
    let currentIndex;
    this.state.activities.map((iterator, index) => {
      if (iterator.name === this.props.currentActivity.name) {
        currentIndex = index;
      }
      return 0;
    })
    if (this.state.activities[currentIndex + 1]) {
      if (this.state.activities[currentIndex + 2]) {
        this.props.setCurrentActivity(
          this.state.activities[currentIndex + 1],
          this.state.activities[currentIndex + 2]
        )
      } else {
        this.props.setCurrentActivity(
          this.state.activities[currentIndex + 1],
          this.state.activities[0]
        )
      }
    } else {
      this.props.setCurrentActivity(
        this.state.activities[0],
        this.state.activities[1]
      )
    }
    // console.log("next activity ", currentIndex);
    //ActvitySelectedColor(this.state.stateCurrentActivity.activityId, this.props.menuColor);
  }

  render() {
    //console.log("stateCurrentActivity", this.state.stateCurrentActivity);
    ActvitySelectedColor(this.state.stateCurrentActivity.activityId, this.props.menuColor)
    return (
      <div
        id="activityWidget"
        className="contentSection columns center-v">
        {/* Div for avivities menu in left side*/}
        <div
          id="activity-list"
          className="col col-2 m-r25 overflowy"
        >
          <div className="activity-heading all-caps">
            {experiences}
          </div>
          {/* {this.state.stateCurrentActivity.activityId ?
               : null
            } */}
          <div className="activity-list-container" >
            {
              Array.isArray(this.state.activities) ?
                this.state.activities.map((iterator, index) => {
                  //console.log("iterator",iterator);
                  return (
                    <div
                      className={
                        this.props.currentActivity.name === iterator.name ?
                          "activity-item current" :
                          "activity-item"
                      }
                      onClick={() => { this.onActivityClick(iterator, index) }}
                      id={`${iterator.activityId}`}
                    >
                      <div className="activity-item-name all-caps" style={{ color: "inherit" }}>
                        {iterator.name}
                      </div>
                      <a href="#" style={{ color: "inherit" }}>
                        <i className="fa fa-chevron-right" style={{ color: "inherit" }}>
                        </i>
                      </a>
                      <div className="activity-item-desc" style={{ color: "inherit" }}>
                        {iterator.description}
                      </div>
                    </div>
                  )
                }) : ""
            }
          </div>
        </div>
        {/* Div to display info of selected activity*/}
        <div
          id="activity-list-results"
          className="col col-2 results-col">

          <div id="activity-results-container">
            <div className="activity-results-options">
              <div className="activity-options-container">
                {
                  <ActvityCard
                    id="currentCard"
                    activity={this.state.stateCurrentActivity}
                    classes="current"
                    index={2}
                    imgBaseUrl={this.props.imgBaseUrl}
                    ani={this.state.signUp}
                  />
                }
                {
                  <ActvityCard
                    activity={this.props.currentActivity}
                    classes="current"
                    imgBaseUrl={this.props.imgBaseUrl}
                    index={1}
                  />}
                {
                  this.props.nextActivity.name ?
                    <ActvityCard
                      activity={this.props.nextActivity}
                      imgBaseUrl={this.props.imgBaseUrl}
                      classes="under"
                      index={0}
                    /> : null
                }
              </div>
              {
                <div className="activity-option-choices center">
                  <a
                    className="activity-act-discard"
                    onClick={() => { this.changeActivity("no thanks") }}
                    style={{ color: "inherit" }}>
                    <i className="fa fa-chevron-left" style={{ marginRight: '5px', color: "inherit" }}></i>
                    {noThanks}
                  </a>
                  <a
                    className="activity-act-accept"
                    onClick={this.addToSignUp}
                    style={{ color: "inherit" }}>
                    {signMeUp}
                    <i className="fa fa-chevron-right" style={{ marginLeft: '5px', color: "inherit" }}></i>
                  </a>
                </div>}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    activities: state.store.activity.activitiesData.activityMaster ?
      state.store.activity.activitiesData.activityMaster : [],
    imgBaseUrl: state.store.activity.activitiesData.imageBaseUrl ?
      state.store.activity.activitiesData.imageBaseUrl : "",
    currentActivity: state.store.activity.currentActivity,
    signUpActivities: state.store.activity.signUpactivities,
    nextActivity: state.store.activity.nextActivity ?
      state.store.activity.nextActivity : {},
    guestDetails: state.store.home.guestDetails,
    resNo: state.store.reservationNo,
    menuColor: state.store.home.MenuColor

  }
}

Activities.propTypes = {
  currentActivity: propTypes.object,
  signUpActivities: propTypes.arrayOf(propTypes.object),
  nextActivity: propTypes.object,
  imgBaseUrl: propTypes.string
}

export default connect(
  mapStateToProps,
  {
    setCurrentActivity,
    setSignUpActivities,
    addToSignUp,
    signUpAct,
    popupOpenClose,
    setLoadingMass
  }
)(Activities);


/*
                  <div className="option-item-rate">
                    <i className="activity-symbol">
                      {
                        this.state.ratingInstars.map((iterator) => {
                          if (iterator === 1) {
                            return <img
                              src={require('../../images/icon/filled-star.svg')}
                              alt="" />
                          }
                          else {
                            return <img
                              src={require('../../images/icon/empty-star.svg')}
                              alt="" />
                          }
                        })
                      }
                    </i>
                  </div>


                  <div className="activity-option-items current"
                  style={this.state.signUp === "signup" ?
                    { transform: 'translate(370px)', zIndex: 2 } :
                    this.state.signUp === "no thanks" ?
                      { transform: 'translate(-370px)', zIndex: 2 } :
                      { zIndex: 2 }}>
                  <div className="option-item-img">
                    </div>
                    <div className="option-item-desc">
                      <span className="title">
                        {this.props.nextActivity.name}
                      </span>
                      {this.props.nextActivity.description}
                    </div>
                    <div className="option-item-soc center">
                      <i className="media">
                        <img
                          src={require('../../images/icon/facebook.svg')}
                          alt="" />
                      </i>
                      <i className="media">
                        <img
                          src={require('../../images/icon/twitter.svg')}
                          alt="" />
                      </i>
                      <i className="media">
                        <img
                          src={require('../../images/icon/instagram.svg')}
                          alt="" />
                      </i>
                    </div>
                  </div>
*/